// phonics_data_lt17.js
// Letter Teams L17 - L17 Digraphs th
// 路由：/phonics/lt17

const MEDIA_BASE = '/media/phonics/lt17';
const V = 'v1';

export const letterDataLt17 = {
  id: 'lt17',
  letter: 'L17',
  title: 'L17 Digraphs th',
  mediaBase: MEDIA_BASE,

  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "Pink sees a box.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "What is in that box?", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "It is a cat.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Its name is Beth.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Beth cries.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Beth, what do you want?", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "She wants to eat.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Pink gets a thin fish.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Beth, eat this.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Squeak! Squeak!", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Here come three mice!", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "They take Beth's fish.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Beth chases them.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "Run, Beth! Run!", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
        { en: "Stop those mice!", audioEn: `${MEDIA_BASE}/story2_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "They run on a path.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "They run to a bath.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Splash! Oh, no!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Beth does not like baths.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
      ],
    },
  ],
};
